module.exports = __webpack_public_path__ + "img/[骷髅].41924d9a.svg";